import Config from '../../../../lib/Config'
import { Budget, BudgetSums, Reconciliation } from '../../../../lib/Types'
import { SheetType } from '../Enums/SheetType'

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
})

export const downloadBudget = async (budget: Budget): Promise<void> => {
  fetch(`${Config.API}/budgets/${budget.id}/download/`, {
    headers: getHeaders(),
  })
    .then((response) => response.blob())
    .then((blob) => {
      // Create a new object URL for the blob
      const url = window.URL.createObjectURL(blob)

      // Create a link and click it
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'budget.csv')
      document.body.appendChild(link)
      link.click()

      // Remove the link after triggering the download
      document.body.removeChild(link)
    })
}

export const getBudgets = async (): Promise<Budget[]> => {
  const response = await fetch(`${Config.API}/budgets/`, {
    headers: getHeaders(),
  })

  if (response.status !== 200) {
    throw response.status
  }

  const budgets = await response.json()

  return budgets.map((budget: Budget) => {
    return {
      ...budget,
      sheet_type: SheetType.BUDGET,
    }
  })
}

export const getBudget = async (id: number): Promise<Budget> => {
  const response = await fetch(`${Config.API}/budgets/${id}/`, {
    headers: getHeaders(),
  })

  if (response.status === 404) {
    throw response.status
  }

  const budget = await response.json()

  return {
    ...budget,
    sheet_type: SheetType.BUDGET,
  }
}

export const getBudgetSums = async (
  budget: Budget,
): Promise<BudgetSums> => {
  const response = await fetch(`${Config.API}/budgets/${budget.id}/sums/`, {
    headers: getHeaders(),
  })

  if (response.status === 404) {
    throw response.status
  }

  return await response.json()
}

export const createBudget = async (): Promise<Budget> => {
  const response = await fetch(`${Config.API}/budgets/`, {
    method: 'POST',
    headers: {
      ...getHeaders(),
      'Content-Type': 'application/json',
    },
  })

  const budget = await response.json()

  return {
    ...budget,
    sheet_type: SheetType.BUDGET,
  }
}

export const getBudgetReconciliations = async (
  budget: Budget,
  year: number,
): Promise<Reconciliation[]> => {
  const response = await fetch(
    `${Config.API}/budgets/${budget.id}/reconciliations/${year}/`,
    {
      method: 'GET',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
      },
    },
  )
  return response.json()
}

export const saveBudgetReconciliation = async (
  reconciliation: Reconciliation,
): Promise<Reconciliation> => {
  const response = await fetch(
    `${Config.API}/budgets/${reconciliation.budget_id}/reconciliation/`,
    {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(reconciliation),
    },
  )

  return await response.json()
}
